import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import * as XCol from '../framework.core/XExportColumn';

export class DepoDetail extends TrackableEntity {
    postDate: string | null = null;
    branch: string = '';
    othInvNo: string = '';
    stbName: string = '';
    block: boolean = false;
    glDescription: string = '';
    entityName: string = '';
    refNo: string = '';
    hblNo: string = '';
    currency: string = '';
    invAmount: number = 0;
    dueAmount: number = 0;
    amount: any = 0;            //음수 핸들링때문에 any type으로 변경
    savAmount: number = 0;      // 원래 Amount 값 
    isSelect: boolean = false;
    glNo: string = '';
    description: string = '';
    balance: number = 0;        // Curr. Balance
    newBalance: number = 0;     // New Balance
    increase: number = 0;
    decrease: number = 0;
    flAmount: number = 0;
    foAmount: number = 0;
    id: number = 0;
    depoHdId: number = 0;
    tbName: string = '';
    tbId: number = 0;
    exrateO: number = 0;
    lAmount: number = 0;
    oAmount: number = 0;
    payType: string = '';
    badARExpenseId: number = 0;
    originGLNo: string = '';
    glDescription2: string = '';
    invNo: string = '';
    sRefNo: string = '';
    paidAmount: number = 0;
    entity: number = 0;
    histID: number = 0;
    realPaidAmount: number = 0;
    cAmount: number = 0;
    sortNo: number = 0;
    mblId: number = 0;
    hblId: number = 0;
    mhName: string = '';
    stbId: number = 0;
    approved: boolean = false;
    confirmed: boolean = false;
    isEPay: boolean = false;

    actId: number = 0;
    nonOpShowOption: string = '';
    //#region Work Sheet
    
    billAmtAR: number = 0;
    dueAmtAR: number = 0;
    isSelectAR: boolean = false;
    
    billAmtAP: number = 0;
    dueAmtAP: number = 0;
    isSelectAP: boolean = false;

    billAmtDutyAR: number = 0;
    dueAmtDutyAR: number = 0;
    isSelectDutyAR: boolean = false;

    billAmtDutyAP: number = 0;
    dueAmtDutyAP: number = 0;
    isSelectDutyAP: boolean = false;

    amtAR: number = 0;
    amtAP: number = 0;
    amtDutyAR: number = 0;
    amtDutyAP: number = 0;

    othRefNo: string = '';
    isInsertRow: boolean = false;

    postDateHistory: string | null = null;
    invNoHistory: string = '';

    schDate: string | null = null;
    dueDate: string | null = null;
    accountName: string = '';
    //#endregion

    isSalesTaxReturn: boolean = false;
    
    sbl: boolean = false;
    
    constructor(init?:Partial<DepoDetail>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('stbName', 'block', 'glDescription', 'entityName', 'refNo', 'hblNo', 'currency', 'invAmount', 
        'dueAmount', 'isSelect', 'balance', 'flAmount', 'foAmount', 'id', 'originGLNo', 'glDescription2', 'invNo', 'sRefNo', 'paidAmount', 
        'entity', 'histID', 'realPaidAmount', 'cAmount', 'sortNo', 'mblId', 'hblId', 'mhName', 'isInsertRow',
        'ar','ap','dutyAr','dutyAp', 'approved','confirmed', 'isEPay','postDateHistory','invNoHistory','actId','schDate', 'dueDate', 'nonOpShowOption','accountName');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return DepoDetail.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_DepoDetail' }),
        'depoHdId': new DBMappingInfo({ field: 'F_DepoHdId', table: 'T_DepoDetail' }),
        'tbId': new DBMappingInfo({ field: 'F_TBId', table: 'T_DepoDetail' }),
        'tbName': new DBMappingInfo({ field: 'F_TBName', table: 'T_DepoDetail' }),
        'amount': new DBMappingInfo({ field: 'F_Amount', table: 'T_DepoDetail' }),
        'glNo': new DBMappingInfo({ field: 'F_GLNo', table: 'T_DepoDetail' }),
        'description': new DBMappingInfo({ field: 'F_Description', table: 'T_DepoDetail' }),
        'branch': new DBMappingInfo({ field: 'F_Branch', table: 'T_DepoDetail' }),
        'othInvNo': new DBMappingInfo({ field: 'F_OthInvNo', table: 'T_DepoDetail' }),
        'exrateO': new DBMappingInfo({ field: 'F_ExrateO', table: 'T_DepoDetail' }),
        'lAmount': new DBMappingInfo({ field: 'F_LAmount', table: 'T_DepoDetail' }),
        'oAmount': new DBMappingInfo({ field: 'F_OAmount', table: 'T_DepoDetail' }),
        'payType': new DBMappingInfo({ field: 'F_PayType', table: 'T_DepoDetail' }),
        'othRefNo': new DBMappingInfo({ field: 'F_OthRefNo', table: 'T_DepoDetail' }),
    };

    private static ExportCollection: XCol.XExportColumn[] = [ //for list sorting when header click
        XCol.Create({ col: 0, text: '', width: 10, dataIndex: 'postDate', type: XCol.XCellType.Date }),
        XCol.Create({ col: 1, text: '', width: 10, dataIndex: 'schDate', type: XCol.XCellType.Date }),
        XCol.Create({ col: 2, text: '', width: 10, dataIndex: 'dueDate', type: XCol.XCellType.Date }),
        XCol.Create({ col: 3, text: '', width: 10, dataIndex: 'branch'}),
        XCol.Create({ col: 4, text: '', width: 10, dataIndex: 'invNo'}),
        XCol.Create({ col: 5, text: '', width: 10, dataIndex: 'stbName'}),
        XCol.Create({ col: 6, text: '', width: 10, dataIndex: 'accountName'}),
        XCol.Create({ col: 7, text: '', width: 10, dataIndex: 'entityName' }),
        XCol.Create({ col: 8, text: '', width: 10, dataIndex: 'refNo' }),
        XCol.Create({ col: 9, text: '', width: 10, dataIndex: 'hblNo' }),
        XCol.Create({ col: 10, text: '', width: 10, dataIndex: 'currency'}),
        XCol.Create({ col: 11, text: '', width: 10, dataIndex: 'invAmount', type: XCol.XCellType.Double }),
        XCol.Create({ col: 12, text: '', width: 10, dataIndex: 'dueAmount', type: XCol.XCellType.Double }),
        XCol.Create({ col: 13, text: '', width: 10, dataIndex: 'block', type: XCol.XCellType.Bool }),
        XCol.Create({ col: 14, text: '', width: 10, dataIndex: 'approved', type: XCol.XCellType.Bool }),
        XCol.Create({ col: 15, text: '', width: 10, dataIndex: 'confirmed', type: XCol.XCellType.Bool }),
        XCol.Create({ col: 16, text: '', width: 10, dataIndex: 'amount', type: XCol.XCellType.Double }),
        XCol.Create({ col: 17, text: '', width: 10, dataIndex: 'isSelect', type: XCol.XCellType.Bool }),
        XCol.Create({ col: 18, text: '', width: 10, dataIndex: 'isEPay', type: XCol.XCellType.Bool }),
      ];
    
      public static getExportCollection(): XCol.XExportColumn[] { //for list sorting when header click
        return this.ExportCollection;
      };
}
